import React, { useEffect, useState } from "react";
import {
  BaseDialog as Dialog,
  useBreakpoint,
  Typography,
  Button,
  Checkbox,
  CircularProgress,
  PayuIcon,
} from "payu-ui/v2";
import {
  getRedirectionConsent,
  postRedirectionConsent,
  updateFinAuthParams,
} from "../services/api/consent";

import { consentType } from "../constants/consentType";

const PayuFinModal = ({userEmail, uuid, open, onClose}) => {
  const [consent, setConsent] = useState(false);
  const [checked, setChecked] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [error, setError] = useState(false);

  const isMobile = useBreakpoint("m");

  useEffect(() => {
      fetchConsent();
  }, []);

  const migrateUserToFin = async () => {
    setShowLoader(true);

    await updateFinAuthParams(uuid)
      .then((response) => {
        if (response?.data?.status === "success")
          window.open(
            `${process.env.PAYUFIN_REDIRECTION_URL}/app/account/signin?user_uuid=${uuid}&email=${userEmail}`, '_self'
          );
        else {
          setShowLoader(false);
          setError(true);
        }
      })
      .catch(() => {
        setShowLoader(false);
        setError(true);
      });
  };

  useEffect(() => {
    if (consent) {
      setTimeout(migrateUserToFin, 2000);
    }
  }, [consent]);

  const handleLinks = (docType, e) => {
    e.preventDefault();
    window.open(docType, "_blank");
  };

  const postConsent = async () => {
    await postRedirectionConsent({
      consents: [
        {
          name: consentType["PG_TO_PAYUFIN"],
          provided_by_uuid: uuid,
          active: true,
        },
      ],
    })
      .then((res) => {
        let consents = res?.data?.consents?.filter(
          (el) => el.name == consentType["PG_TO_PAYUFIN"]
        );
        if (consents.length > 0) {
          setConsent(true);
        }
      })
      .catch((err) => {
        setError(true);
      });
  };

  const fetchConsent = async () => {
    await getRedirectionConsent()
      .then((res) => {
        setShowLoader(false);
        let consents =
          res?.data?.consents?.filter(
            (el) => el.name == consentType["PG_TO_PAYUFIN"]
          ) || []; //TODO
        if (consents.length > 0) {
          setConsent(true);
        } else setConsent(false);
      })
      .catch((err) => {
        setError(true);
        setShowLoader(false);
      });
  };

  return (
    <div className="tw-preflight">
        <Dialog
          open={open}
          onClose={onClose}
          showCloseIcon={false}
          enableOutsideClickHandler={false}
          className={`!twside-max-h-[90vh] !twside-max-w-\[60vw\] ${isMobile ? 'twside-min-h-[229px]' : "!twside-min-w-[664px] !twside-min-h-[304px]"}`}
        >
          {
            <React.Fragment>
              {showLoader ? (
                <div
                  className={`twside-flex tw-items-center tw-justify-center ${isMobile ? 'twside-min-h-[229px]' : "!twside-min-w-[664px] !twside-min-h-[304px]"}`}
                >
                  <CircularProgress />
                </div>
              ) : error ? (
                <div className="twside-py-50 twside-mx-16 twside-my-16">
                  <div className="twside-flex twside-justify-end">
                    <PayuIcon
                      type="cross-icon"
                      className="twside-text-gray-100 tw-cursor-pointer"
                      onClick={onClose}
                    />
                  </div>
                  <div className="twside-flex twside-justify-center">
                    <PayuIcon
                      type="info-circle"
                      className={`twside-text-red-500 ${isMobile ? "twside-h-[75px]" : "twside-h-100"}`}
                    />
                  </div>
                  <div className="twside-flex twside-flex-col twside-items-center twside-justify-center twside-mx-19 tw-text-center  twside-mx-25 twside-mt-24">
                    <Typography
                      variant={isMobile ? "P2" : "SH2"}
                      weight={isMobile ? "regular" : "bold"}
                      className="tw-text-primary-900 tw-pb-8"
                    >
                      Something went wrong!
                    </Typography>

                    <Typography
                      variant={isMobile ? "P2" : "P1"}
                      weight="regular"
                      className="twside-text-gray-80 tw-text-center twside-mx-16 twside-max-w-[600px]"
                    >
                      We are unable to fetch your information. Please try again
                      or come back later and try.
                    </Typography>
                  </div>
                </div>
              ) : (
                <div className="tw-preflight">
                  <div className="twside-py-24 twside-my-16 twside-mx-16">
                    <img
                      src={`${process.env.MEDIA_HOST}/images/redirection-logo.svg`}
                      style={{ margin: "auto", width: "65%" }}
                    />
                    <div className={`twside-flex twside-flex-col twside-items-center twside-justify-center tw-text-center ${isMobile ? "twside-px-[30px]" : ""}`}>
                      <Typography
                        variant={isMobile ? "P2" : "SH2"}
                        weight={isMobile ? "regular" : "bold"}
                        className="twside-text-primary-900"
                      >
                        {consent
                          ? "Redirecting you to PayU finance..."
                          : "You are being redirected to PayU finance (a PayU entity)"}
                      </Typography>
                      {!consent && (
                        <div className={`${isMobile ? "twside-mx-[-30px]" : "twside-mx-[120px] twside-mt-4"}`}>
                        <Typography
                          variant={isMobile ? "P2" : "P1"}
                          weight="regular"
                          className="twside-text-gray-80 tw-text-center twside-mx-16"
                        >
                          Rest assured your data and preferences remain secure.
                          To proceed with the redirection we be will needing
                          your consent
                        </Typography>
                        </div>
                      )}
                      <span className="twside-flex twside-mt-24">
                        {" "}
                        {/* <PayuIcon type={"shield-icon"} /> */}
                        <img
                          src={`${process.env.MEDIA_HOST}/images/shield-icon.svg`}
                        />
                        <Typography variant="P2">100% safe & secure</Typography>
                      </span>
                    </div>
                  </div>

                  {!consent && (
                    <div
                      className={`${
                        isMobile ? "twside-flex-col" : ""
                      } tw-bg-gray-40 twside-p-16 twside-flex twside-justify-between twside-sticky twside-bottom-0`}
                    >
                      <div className="twside-flex">
                        <Checkbox
                          id="chckbx-2"
                          name="chckbx-2"
                          checked={checked}
                          onChange={() => setChecked(!checked)}
                        />
                        <Typography
                          variant="P2"
                          weight={isMobile ? "regular" : "semi-bold"}
                          className="tw-pr-4"
                        >
                          I hereby accept &nbsp;
                          <a
                            href="#"
                            className="tw-text-primary-500"
                            onClick={(e) =>
                              handleLinks(
                                `${process.env.TXN_MEDIA_HOST}/document/payufin-consents/payu_consent.pdf`,
                                e
                              )
                            }
                          >
                            PayU Payments Consent Letter
                          </a>
                          &nbsp; for the purposes of assessing my eligibility
                          and facilitating my onboarding for Lending Products
                          provided by Lender.
                        </Typography>
                      </div>
                      <div
                        className={`${
                          isMobile ? "twside-justify-center twside-mt-[16px]" : ""
                        } twside-sticky twside-bottom-0 twside-flex twside-gap-x-8 `}
                      >
                        <Button
                          size={isMobile ? "large" : "medium"}
                          variant="SECONDARY"
                          fullWidth={isMobile}
                          onClick={onClose}
                        >
                          Cancel
                        </Button>
                        <Button
                          size={isMobile ? "large" : "medium"}
                          variant="PRIMARY"
                          fullWidth={isMobile}
                          onClick={postConsent}
                          disabled={!checked}
                        >
                          Continue
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </React.Fragment>
          }
        </Dialog>
    </div>
  );
};

export default PayuFinModal;
